import { reactive, ref } from 'vue';

export enum expireTypeEnum {
  expire,
  disable,
}

export enum planExpireTypeEnum {
  member = 'member',
  storage = 'storage',
  memberAndStorage = 'memberAndStorage',
}

export const resetIsExpireStore = () => {
  isExpireStore.isExpire = false;
  isExpireStore.type = expireTypeEnum.expire;
  isExpireStore.planExpireType = undefined;
};

export const isExpireStore = reactive<{
  isExpire: boolean;
  type: expireTypeEnum;
  planExpireType: Undefinedable<planExpireTypeEnum>;
}>({
  isExpire: false,
  type: expireTypeEnum.expire,
  planExpireType: undefined,
});

export const isLicenseExpired = ref(false);
